frappe.ui.form.ControlDatetime = class ControlDatetime extends frappe.ui.form.ControlDate {
	set_formatted_input(value) {
		if (this.timepicker_only) return;
		if (!this.datepicker) return;
		if (!value) {
			this.datepicker.clear();
			this.datepicker.date = this.get_now_date();
			return;
		} else if (value.toLowerCase() === "today") {
			value = this.get_now_date();
		} else if (value.toLowerCase() === "now") {
			value = frappe.datetime.now_datetime();
		}
		const should_refresh = this.last_value && this.last_value !== value;
		value = this.format_for_input(value);
		this.$input && this.$input.val(value);
		if (should_refresh) {
			this.datepicker.selectDate(frappe.datetime.user_to_obj(value));
		} else if (value) {
			this.sync_datepicker_state(frappe.datetime.user_to_obj(value));
		}
	}

	sync_datepicker_state(date) {
		const selected_date = this.datepicker.selectedDates[0];
		const last_selected_date = this.datepicker.lastSelectedDate;
		const timepicker = this.datepicker.timepicker;
		const date_value = date.getTime();
		const has_stale_time =
			timepicker &&
			(Number(timepicker.hours) !== date.getHours() ||
				Number(timepicker.minutes) !== date.getMinutes() ||
				Number(timepicker.seconds) !== date.getSeconds());
		const has_stale_state =
			!selected_date ||
			selected_date.getTime() !== date_value ||
			!last_selected_date ||
			last_selected_date.getTime() !== date_value ||
			has_stale_time;

		if (!has_stale_state) return;

		this.datepicker.selectedDates = [date];
		this.datepicker.lastSelectedDate = date;
		this.datepicker.date = date;

		if (timepicker) {
			timepicker._setTime(date);
			timepicker.update();
		}
	}

	get_start_date() {
		this.value = this.value == null || this.value == "" ? undefined : this.value;
		let value = frappe.datetime.convert_to_user_tz(this.value);
		return frappe.datetime.str_to_obj(value);
	}
	set_date_options() {
		super.set_date_options();
		this.today_text = __("Now");
		let sysdefaults = frappe.boot.sysdefaults;
		this.date_format = frappe.defaultDatetimeFormat;
		let time_format =
			sysdefaults && sysdefaults.time_format ? sysdefaults.time_format : "HH:mm:ss";
		$.extend(this.datepicker_options, {
			timepicker: true,
			timeFormat: time_format.toLowerCase().replace("mm", "ii"),
		});
	}
	get_now_date() {
		return frappe.datetime.now_datetime(true);
	}
	parse(value) {
		if (value) {
			value = this.eval_expression(value, "datetime");

			if (!frappe.datetime.is_system_time_zone()) {
				value = frappe.datetime.convert_to_system_tz(value, true);
			}

			if (value == "Invalid date") {
				value = "";
			}
		}
		return value;
	}
	format_for_input(value) {
		if (!value) return "";
		return frappe.datetime.str_to_user(value, false);
	}
	// No set_description() override on purpose. Upstream appends the system time zone to
	// every Datetime field's description; PCG runs a single time zone, so that line is noise
	// under every date field in the Desk. Without the override, base_input's
	// set_description() renders the plain (translated) description. On pcg-16-released31 the
	// same was achieved by commenting the method out.
	get_user_time_zone() {
		return frappe.boot.time_zone ? frappe.boot.time_zone.user : frappe.sys_defaults.time_zone;
	}
	set_datepicker() {
		super.set_datepicker();
		if (this.datepicker.opts.timeFormat.indexOf("s") == -1) {
			// No seconds in time format
			const $tp = this.datepicker.timepicker;
			$tp.$seconds.parent().css("display", "none");
			$tp.$secondsText.css("display", "none");
			$tp.$secondsText.prev().css("display", "none");
		}
	}

	get_model_value() {
		let value = super.get_model_value();
		if (!value && !this.doc) {
			value = this.last_value;
		}
		return !value ? "" : frappe.datetime.get_datetime_as_string(value);
	}
};
